import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { LOGO } from "@/components/tam/Sidebar";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

const HERO = "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="tam-secure min-h-screen grid lg:grid-cols-[1.1fr_1fr]" onContextMenu={(e) => e.preventDefault()}>
      <div className="relative hidden lg:flex flex-col justify-between p-12 bg-[#0B132B] text-white overflow-hidden">
        <img src={HERO} alt="" className="absolute inset-0 w-full h-full object-cover opacity-25" />
        <img src={LOGO} alt="EP Group" className="relative w-56" />
        <div className="relative max-w-lg tam-fade">
          <p className="uppercase tracking-[0.25em] text-xs text-[#D9232A] font-semibold mb-4">Targeted Account Management</p>
          <p className="text-slate-300">Innovator of packaging and consumables, manufacturer for retail and hospitality.</p>
        </div>
        <p className="relative text-xs text-slate-400">Confidential · All activity is recorded and audited</p>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12">
        <form onSubmit={submit} className="w-full max-w-sm space-y-6 tam-fade" data-testid="login-form">
          <div className="lg:hidden bg-[#0B132B] p-4 rounded-md"><img src={LOGO} alt="EP Group" className="w-40" /></div>
          <div>
            <h2 className="text-3xl font-extrabold text-[#0B132B]">Sign in to TAM</h2>
            <p className="text-sm text-slate-500 mt-2">Use the account issued by your manager.</p>
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" />
          </div>
          {error && <p className="text-sm text-[#D9232A]" data-testid="login-error">{error}</p>}
          <Button type="submit" disabled={busy} className="w-full h-11 bg-[#D9232A] hover:bg-[#B81920]" data-testid="login-submit-btn">
            {busy ? "Signing in…" : "Sign in"}
          </Button>
        </form>
      </div>
    </div>
  );
}
